import { combineReducers, Reducer } from "@reduxjs/toolkit";
import refillReducer from "./reducers/refillReducer";
import registrationReducer from "./reducers/registrationReducer";
import { FORM_ID } from "../../../../constants";
import { createReducer } from "../../rapidform";

const reducer: Reducer = combineReducers({
    registration: registrationReducer,
    refill: refillReducer,
    [FORM_ID.REGISTER_PREPAID]: createReducer(FORM_ID.REGISTER_PREPAID),
    [FORM_ID.REFILL_PREPAID]: createReducer(FORM_ID.REFILL_PREPAID),
});

export default reducer;
